import { forwardRef } from 'react';

import { IconProps } from '.';

export const CheckIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        fill="currentColor"
        d="M14.67 5.91999L15.4 6.64999C15.4575 6.7059 15.5031 6.77276 15.5343 6.84661C15.5655 6.92047 15.5816 6.99982 15.5816 7.07999C15.5816 7.16016 15.5655 7.23951 15.5343 7.31337C15.5031 7.38722 15.4575 7.45408 15.4 7.50999L8.84 14.07C8.78409 14.1274 8.71723 14.1731 8.64338 14.2043C8.56952 14.2355 8.49017 14.2515 8.41 14.2515C8.32983 14.2515 8.25048 14.2355 8.17662 14.2043C8.10277 14.1731 8.03591 14.1274 7.98 14.07L4.6 10.69C4.54255 10.6341 4.49688 10.5672 4.4657 10.4934C4.43451 10.4195 4.41845 10.3402 4.41845 10.26C4.41845 10.1798 4.43451 10.1005 4.4657 10.0266C4.49688 9.95276 4.54255 9.8859 4.6 9.82999L5.33 9.09999C5.44552 8.98877 5.59964 8.92664 5.76 8.92664C5.92036 8.92664 6.07448 8.98877 6.19 9.09999L8.41 11.32L13.81 5.91999C13.9255 5.80877 14.0796 5.74664 14.24 5.74664C14.4004 5.74664 14.5545 5.80877 14.67 5.91999Z"
      />
    </svg>
  );
});
export default CheckIcon;
